import { Action, createReducer, on } from "@ngrx/store";

import { cameraActions } from "./camera.actions";
import { initialState } from "./camera.state";

export const cameraReducer = createReducer(
  initialState,
  on(
    cameraActions.targetMoved,
    cameraActions.initCamera,
    (state, { target }) => ({
      ...state,
      target: target,
    }),
  ),
  on(
    cameraActions.addRewindCheckpointTarget,
    (state, { target }) => {
      let history = [...state.history]
      history.push(target)
      return {
        ...state,
        history
      }
    },
  ),
  on(
    cameraActions.popCheckpointHistory,
    (state) => {
      let history = [...state.history]
      history.pop()
      return {
        ...state,
        history
      }
    }
  ),
  on(cameraActions.zoomChanged, (state, { absoluteZoom }) => ({
    ...state,
    zoom: absoluteZoom,
  })),
  on(cameraActions.toggleTracking, (state, { enabled }) => ({
    ...state,
    isTracking: enabled,
  })),
  on(cameraActions.toggleMapMode, (state, { enabled }) => ({
    ...state,
    mapMode: enabled,
  })),
);
